// app/didatticaCompetenze/didattiche.js

(function () {
    'use strict';
    var controllerId = 'didatticaCompetenze';
    angular.module('app').controller(controllerId, ['common', '$rootScope', 'bootstrap.dialog', '$routeParams', '$uibModal', '$filter', 'datacontext', 'sectionMenu', 'filterFilter', '$translate', didatticaCompetenze]);

    function didatticaCompetenze(common, $rootScope, bDialog, $routeParams, $uibModal, $filter, datacontext, sectionMenu, filterFilter, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'DidatticaCompetenze';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "DidatticaCompetenze"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        //vm.addDisabled = !$rootScope.licenzaValida;
        vm.addTitle = $translate.instant('Nuova');
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;        

        //Elenco per Ordinamento
        vm.list = {};        
        vm.list.ordine = ['Materie', 'Anno'];
        if (!vm.super)
            vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[1];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            cerca();
        };

        vm.getRecord = getRecord;

        //Filtro
        vm.filter = {};
        vm.filter.anno = -1;
        vm.filter.materia = 0;

        vm.currentLanguage = $translate.proposedLanguage() || $translate.use();

        //filter per Anno: default l'anno corrente        
        vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        vm.filter.anno = vm.fAnno;
                        
        vm.attivaDidattica = attivaDidattica;
        vm.annullaDidattica = annullaDidattica;

        //modale dettaglio abilit� e conoscenze
        vm.modalDetailAC = modalDetailAC;
        vm.item = {};

        vm.valutazioni = [];
        vm.salvaValutazioni = salvaValutazioni;
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;

        vm.get = getRecord;        
        vm.add = addModal;
        vm.delete = deleteItem;
        vm.materie = [];

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getMaterie()];
            common.activateController(promises, controllerId).then(function () {
                getValutazioni();
            });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function getMaterie() {
            datacontext.materia_getAllList().then(function (data) {
                return vm.materie = data;
            });
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.anno = vm.fAnno == null ? -1 : vm.fAnno;
            vm.filter.materia = vm.fMateriaId == null ? 0 : vm.fMateriaId;                        
            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.schedaCompetenzeDoc_countAll(vm.filter.anno, vm.filter.materia).then(function (data) {
                //console.dir(data);
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {            
            if (vm.loading === true) return;            
            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.schedaCompetenzeDoc_getAllByDocId(vm.filter.anno, vm.filter.materia, vm.ordine.value).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(item) {
            var annoScolastico = '';
            vm.item.titolo = item.Titolo;
            if (item.AnnoScolastico == 1)
                annoScolastico = "PrimoBiennio";
            else if (item.AnnoScolastico == 2)
                annoScolastico = "SecondoBiennio";
            else if(item.AnnoScolastico == 5)
                annoScolastico = "QuintoAnno";
            vm.item.annoScolastico = annoScolastico
            setView('detail');
            var isFirst = false;
            var asseDoc = {};
            return datacontext.asseCulturale_get(item.AsseId).then(function (asse) {

                return datacontext.schedaCompetenzeDoc_getAll(item.Anno, item.MateriaId, item.DocenteId, asse.Id).then(function (scCompDoc) {
                    asse.CompetenzeChiave.forEach(function (cChiave) {
                        cChiave.CompetenzeBase.forEach(function (cBase) {
                            if (scCompDoc.length > 0) {
                                vm.scCompDoc = scCompDoc;

                                var check = _.find(scCompDoc, function (o) {
                                    return o.CompBaseId == cBase.Id;
                                });
                                //if (!check) {
                                //    //aggiungo riga
                                //    schedaCompetenzeDocAdd(asse.Id, cChiave.Id, cBase.Id);
                                //}
                                if (check) {
                                    cBase.Attivo = cChiave.Attivo = check.Attivo;
                                    cBase.Personalizzazione1 = check.Personalizzazione1;
                                    cBase.Personalizzazione2 = check.Personalizzazione2;
                                    cBase.Peso = check.Peso;
                                }
                                return vm.assi = asse;
                            }
                            else {
                                vm.assi = {};
                                asseDoc = asse;
                            }
                        });
                    });
                });
            });
        }

        function attivaDidattica() {
            datacontext.schedaCompetenze_attiva().then(function (data) {
                if (!data || !data.Id || data.Id == 0) {
                    logError($translate.instant('OperazioneNonRiuscita'));
                    return;
                }
                logSuccess($translate.instant('DidatticaCompetenzeAttiva'));
                $rootScope.didattica = data.DidatticaCompetenze;                
            });
        }

        function annullaDidattica() {
            var msg = $translate.instant('AvvisoAnnullareDidattica');
            bDialog.confirmationDialog($translate.instant('Conferma'), msg).then(function () {
                datacontext.schedaCompetenze_annulla().then(function (data) {
                    if (!data || !data.Id || data.Id == 0) {
                        logError($translate.instant('OperazioneNonRiuscita'));
                        return;
                    }
                    $rootScope.didattica = data.DidatticaCompetenze;
                    vm.assi = {};
                    logSuccess($translate.instant('DidatticaCompetenzeDisattiva'));                    
                });
            });
        }

        function salvaSchedaCompetenze() {
            vm.scCompDoc.forEach(function (item) {

                vm.assi.CompetenzeChiave.forEach(function (cChiave) {
                    cChiave.CompetenzeBase.forEach(function (cBase) {
                        if (cBase.Id == item.CompBaseId) {
                            item.Attivo = cBase.Attivo = cChiave.Attivo;
                            item.Personalizzazione1 = cBase.Personalizzazione1;
                            item.Personalizzazione2 = cBase.Personalizzazione2;
                            item.Peso = cBase.Peso;
                            datacontext.schedaCompetenzeDoc_update(item).then(function () {

                            });
                        }
                    });
                });
            });
            logSuccess($translate.instant('DatiSalvati'));
            vm.flag_modifica = 0;
        }

        function getValutazioni() {
            vm.valutazioni = [];
            return datacontext.valutazioneDoc_getAll().then(function (data) {
                return vm.valutazioni = data;               
            });
        }

        function salvaValutazioni() {
            vm.valutazioni.forEach(function (v) {
                datacontext.valutazioneDoc_update(v).then(function () { });
            });

            logSuccess($translate.instant('DatoSalvato'));
        }

        //Metodi modale
        //modale visualizzazione dettaglio abilit� e conoscenze
        function modalDetailAC(item) {
            var modalDetail = {};
            angular.copy(item, modalDetail);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/didatticaCompetenze/modal/schedaCompetenzeProfiloDetail.html?version=43',
                controller: 'schedaCompetenzeProfiloDetail',
                windowClass: 'modal-wide',
                resolve: {                      // in resolve si indicano, separati da virgola, gli oggetti che vuoi passare alla modale
                    schedaCompetenzeDetail: function () {
                        return modalDetail;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                item.Personalizzazione1 = returnItem.Personalizzazione1; //item.Personalizzazione1 � l'oggetto originale a cui assegno l'oggetto modificato nella modale
                item.Personalizzazione2 = returnItem.Personalizzazione2; //item.Personalizzazione2 � l'oggetto originale a cui assegno l'oggetto modificato nella modale
                item.Peso = returnItem.Peso; //item.Peso � l'oggetto originale a cui assegno l'oggetto modificato nella modale
                if (item.Peso > 0)
                    item.Attivo = true;
                else
                    item.Attivo = false

                salvaSchedaCompetenze()
            });
        }

        function addModal() {
            datacontext.materia_getAllList().then(function (data) {
                var modalInstance = $uibModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: '/app/didatticaCompetenze/modal/didatticaCompetenzaAdd.html?version=43',
                    controller: 'didatticaCompetenzaAdd',
                    resolve: {
                        materie: function () {
                            return data;
                        }
                    }
                });
                modalInstance.result.then(function (returnItem) {
                    if (!returnItem || returnItem == 400) return logError($translate.instant('ErroreCreazione'));
                    logSuccess($translate.instant('DatoSalvato'));
                    cerca();
                });
            });
        }

        function deleteItem(item) {
            var anno = '';
            if (item.AnnoScolastico == 1)
                anno = $translate.instant('PrimoBiennio');
            else if (item.AnnoScolastico == 2)
                anno = $translate.instant('SecondoBiennio');
            else if (item.AnnoScolastico == 2)
                anno = $translate.instant('QuintoAnno');

            var msg = ' ' + $translate.instant('DidatticaCompetenze') + ' ' + $translate.instant('X') + ' ' + item.Titolo + ' ' + anno;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.schedaCompetenzeDoc_delete(item.MateriaId, item.DocenteId, item.AsseId, item.Anno).then(function (data) {
                    //if (data != "204") return logError($translate.instant('ErroreRimozione'));
                    var index = vm.records.indexOf(item);
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }
    }
})();
